export default __webpack_public_path__ + "static/media/OET.0e5e3ac2.png";